import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-saintbrand-infinite-marquee.js';
import productReviewsJson from '@/assets/json/product-reviews.json';

const VERIFIED_SVG = `<svg class="saintbrand-infinite-marquee-verified" enable-background="new 0 0 609.626 609.626" viewBox="0 0 609.626 609.626" xmlns="http://www.w3.org/2000/svg"><path d="m567.469 245.053c-7.825-5.254-14.893-11.556-21.004-18.732.454-9.991 2.462-19.85 5.953-29.221 6.561-22.213 14.733-49.858-1.016-71.49-15.863-21.804-44.842-22.536-68.123-23.131-9.794.391-19.591-.662-29.078-3.126-5.216-8.182-9.199-17.087-11.82-26.43-7.768-22.123-17.445-49.658-43.361-58.08-25.147-8.173-47.715 7.355-67.614 21.01-7.997 6.385-16.975 11.432-26.586 14.946-9.616-3.51-18.599-8.558-26.597-14.946-19.9-13.667-42.474-29.146-67.615-21.01-25.909 8.422-35.583 35.943-43.36 58.071-2.616 9.296-6.555 18.168-11.696 26.343-9.517 2.539-19.363 3.622-29.204 3.213-23.28.594-52.259 1.327-68.122 23.13-15.749 21.644-7.578 49.289-1.016 71.504 3.45 9.322 5.476 19.11 6.009 29.036-6.084 7.277-13.178 13.647-21.066 18.914-18.784 14.325-42.153 32.159-42.153 59.756s23.369 45.431 42.157 59.757c7.825 5.254 14.893 11.556 21.004 18.732-.454 9.991-2.462 19.849-5.953 29.221-6.561 22.213-14.733 49.86 1.016 71.49 15.863 21.804 44.842 22.536 68.123 23.132 9.794-.391 19.591.662 29.078 3.126 5.216 8.182 9.199 17.088 11.82 26.43 7.777 22.127 17.451 49.659 43.366 58.083 4.591 1.505 9.393 2.271 14.225 2.27 19.504 0 37.314-12.242 53.389-23.28 7.997-6.387 16.975-11.435 26.587-14.95 9.616 3.51 18.599 8.558 26.599 14.946 19.899 13.667 42.467 29.134 67.614 21.01 25.909-8.422 35.583-35.943 43.36-58.071 2.616-9.296 6.555-18.168 11.696-26.343 9.517-2.539 19.363-3.622 29.204-3.213 23.28-.594 52.259-1.327 68.122-23.13 15.749-21.643 7.578-49.29 1.016-71.504-3.45-9.322-5.476-19.11-6.009-29.036 6.084-7.277 13.178-13.647 21.066-18.914 18.776-14.325 42.145-32.159 42.145-59.756.001-27.597-23.368-45.431-42.156-59.757zm-149.442 14.214-127.006 127.005c-9.916 9.919-25.995 9.922-35.914.006-.002-.002-.004-.004-.006-.006l-63.503-63.503c-10.045-9.793-10.249-25.875-.456-35.92s25.875-10.249 35.92-.456c.154.15.306.302.456.456l45.543 45.544 109.046-109.047c9.793-10.045 25.875-10.248 35.92-.455s10.248 25.875.455 35.92c-.15.155-.302.306-.455.456z"></path></svg>`;

const defaultReviewContent = [
  'Didn’t think they’d look good on me, but I was wrong. Wear them for driving every day now.',
  'Took them out on the trail and ended up wearing them all day. So comfortable too',
  "They feel light, look good, and keep the sun out of my eyes while I'm driving",
  "Was nervous to buy at first, but I'm glad I did — these have become my everyday go-to.",
  'After losing mine once on the boat, I reorder immediately. They are that good.',
  'Comfortable fit and great clarity. I wear them every day on the water.',
  'Solid build quality and they look even better in person than online.',
  'These sunglasses have held up through fishing trips, hikes, and daily commutes.',
];

const getCardPosition = index => (index % 2 === 0 ? 'top' : 'bottom');

const getCardOffset = index => {
  const mod = index % 4;
  if (mod === 0 || mod === 2) {
    return mod === 0 ? 'far' : 'near';
  }
  return mod === 1 ? 'near' : 'far';
};

const buildReviewCard = (review, position) => `
  <div
    class="saintbrand-infinite-marquee-review-card saintbrand-infinite-marquee-review-card--${position}"
    data-attribute="saintbrand-infinite-marquee-review-card"
    data-position="${position}"
  >
    <img
      loading="lazy"
      class="saintbrand-infinite-marquee-review-avatar"
      data-attribute="saintbrand-infinite-marquee-review-avatar"
      src="${review.avatar || ''}"
      alt=""
    />
    <div class="saintbrand-infinite-marquee-review-body">
      <div class="saintbrand-infinite-marquee-review-name-row">
        <span data-attribute="saintbrand-infinite-marquee-review-name">${review.name || ''}</span>
        ${VERIFIED_SVG}
      </div>
      <div data-attribute="saintbrand-infinite-marquee-review-content">${review.content || ''}</div>
    </div>
  </div>`;

const defaultItems = defaultReviewContent.map((content, index) => {
  const reviewer = productReviewsJson[index] || productReviewsJson[0];

  return {
    review: {
      image: reviewer.avatar,
      avatar: reviewer.avatar,
      name: reviewer.fullName,
      content,
    },
  };
});

const renderSlide = (item, index, isOriginal = true) => {
  const cardPosition = getCardPosition(index);
  const cardOffset = getCardOffset(index);
  const review = item.review || {};

  return `
  <div
    data-attribute="saintbrand-infinite-marquee-slide"
    class="saintbrand-infinite-marquee-slide marquee-item-original"
    data-original="${isOriginal}"
    data-slide-index="${index}"
    data-card-position="${cardPosition}"
    data-card-offset="${cardOffset}"
  >
    <div
      class="saintbrand-infinite-marquee-image-zone"
      data-attribute="saintbrand-infinite-marquee-image-zone"
    >
      <div class="saintbrand-infinite-marquee-image" data-attribute="saintbrand-infinite-marquee-image">
        <img
          loading="lazy"
          data-attribute="saintbrand-infinite-marquee-review-image"
          src="${review.image || ''}"
          alt=""
        />
      </div>
    </div>
    <div
      class="saintbrand-infinite-marquee-card-zone saintbrand-infinite-marquee-card-zone--top"
      data-attribute="saintbrand-infinite-marquee-card-zone-top"
    >
      ${cardPosition === 'top' ? buildReviewCard(review, 'top') : ''}
    </div>
    <div
      class="saintbrand-infinite-marquee-card-zone saintbrand-infinite-marquee-card-zone--bottom"
      data-attribute="saintbrand-infinite-marquee-card-zone-bottom"
    >
      ${cardPosition === 'bottom' ? buildReviewCard(review, 'bottom') : ''}
    </div>
  </div>`;
};

const contentHtml = `
  <div class="wrap-saintbrand-infinite-marquee" data-attribute="saintbrand-infinite-marquee-content">
    <div
      data-attribute="saintbrand-infinite-marquee-title"
      class="saintbrand-infinite-marquee-title"
    >
    </div>
    <div class="saintbrand-infinite-marquee-wrapper" data-attribute="saintbrand-infinite-marquee-wrapper">
      <div
        class="saintbrand-infinite-marquee-container"
        data-attribute="saintbrand-infinite-marquee-container"
        data-pause-on-hover="true"
      >
        <div
          data-attribute="saintbrand-infinite-marquee-list"
          class="saintbrand-infinite-marquee-list"
        >
          ${defaultItems.map((item, index) => renderSlide(item, index)).join('')}
        </div>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: true,
  bottomPadding: true,
});
